// EM²c construction economy invariant.
// A building's CONSTRUCTION cost may never contain a resource that the same
// building can produce, including selectable recipe outputs.

import { EM2C_BUILDINGS } from "./em2c-buildings";
import { FACTORY_RECIPES } from "./productionChains";

const RESOURCE_ALIASES = {
  metal: "refined_metal",
  refined_metal: "refined_metal",
  parts: "machine_parts",
  machine_parts: "machine_parts",
  research: "research_points",
  research_points: "research_points",
};
const normalize = (key) => RESOURCE_ALIASES[key] || key;

function collectPossibleOutputs(type, def) {
  const produced = new Set();
  for (const [key, amount] of Object.entries(def?.productionOutputs || {})) {
    if (Number(amount) > 0) produced.add(normalize(key));
  }
  for (const recipe of FACTORY_RECIPES[type] || []) {
    for (const [key, amount] of Object.entries(recipe.outputs || {})) {
      if (Number(amount) > 0) produced.add(normalize(key));
    }
  }
  return produced;
}

export function validateConstructionEconomy() {
  const violations = [];
  for (const [type, def] of Object.entries(EM2C_BUILDINGS)) {
    const produced = collectPossibleOutputs(type, def);
    for (const [key, amount] of Object.entries(def.cost || {})) {
      if (Number(amount) > 0 && produced.has(normalize(key))) {
        violations.push(`${type}: construction requires its own output ${normalize(key)}`);
      }
    }
  }
  if (violations.length) throw new Error(`[EM²c economy invariant] Self-produced construction cost detected:\n${violations.join("\n")}`);
  return true;
}

export function applyConstructionEconomyRules() {
  return validateConstructionEconomy();
}

applyConstructionEconomyRules();
